import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';

interface CheckToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  testId: string;
  /** Accessible name; also used as the tooltip when the toggle has no label. */
  label?: string;
  disabled?: boolean;
}

/**
 * Compact on/off toggle rendered as a check circle: filled blue with a tick
 * when on, grey and empty when off. Used for the notification recipient and
 * channel toggles, where the control sits directly beside its name.
 */
export const CheckToggle: React.FC<CheckToggleProps> = ({
  checked,
  onCheckedChange,
  testId,
  label,
  disabled,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    title={label}
    disabled={disabled}
    onClick={() => onCheckedChange(!checked)}
    className={cn(
      'flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-full border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      checked
        ? 'border-prosigliere-blue bg-prosigliere-blue text-pure-white'
        : 'border-prosigliere-grey bg-prosigliere-grey text-transparent'
    )}
    data-testid={testId}
  >
    {checked && <Check className="h-3 w-3" />}
  </button>
);
